
import Breadcrumbs from "~/components/UI/Breadcrumbs";
import {formaterOgTitle} from "~/helpers/formaterOgTitle";

export default {
  name: "index",

  head: function () {
    const title = this.seoTitle;
    const description = this.seoDescription;

    return {
      title: title,
      meta: [
        {name: 'og:title', hid: 'og:title', property: 'og:title', content: formaterOgTitle(title, this.$store.state.appState.config)},

        {hid: 'metadescription', name: 'description', content: description},
        {hid: 'og:description', name: 'og:description', property: 'og:description', content: description}
      ],
    }
  },
  asyncData: async function (ctx) {
    const { $api, route, error } = ctx;
    const cityFrom = route?.params?.cityfrom || "";
    const cityTo = route?.params?.cityto || "";
    const infoCity = await $api.agent.transport.get(`/route/from-to?slug_from=${cityFrom}&slug_to=${cityTo}`).then((res) => {
      return res.data
    }).catch(() => {
      return null
    });
    if (!infoCity || infoCity.length <= 0) {
      error(404);
      return
    }

    return {
      infoCity: infoCity
    }
  },

  computed: {
    breadcrumbs: function () {
      const cityFrom = (this.infoCity?.[0]?.city_from_case || this.infoCity?.[0]?.city_from || "");
      const cityTo = (this.infoCity?.[0]?.city_to_case || this.infoCity?.[0]?.city_to || "");

      return [
        { title: "Главная", path: "/" },
        { title: "Грузоперевозки по России", path: "/routes" },
        { title: `из ${cityFrom}`, path: `/routes/${this.$route.params?.cityfrom}` },
        { title: `в ${cityTo}`, path: this.$route.path },
      ]
    },

    h1: function () {
      return `Грузоперевозки ${this.cityFrom} – ${this.cityTo}`
    },
    seoTitle: function () {
      return `Грузоперевозки ${this.cityFrom} – ${this.cityTo}, цены на перевозку грузов`
    },
    seoDescription: function () {
      return `Грузоперевозки ${this.cityFrom} – ${this.cityTo} выделенным транспортом от Газели до фуры 20 тонн и низкорамными тралами. Транспортная компания Централ Транс`
    },

    cityFrom: function () {
      return this.infoCity?.[0]?.city_from || ""
    },
    cityTo: function () {
      return this.infoCity?.[0]?.city_to || ""
    },
    cityUser: function () {
      return this.$store.state?.appState?.config?.city?.data?.city_name
    },
    defaultSubdomain: function () {
      return this.$store.state?.appState?.vars?.['Дефолтный SLUG города'] || ""
    },

    ckEditorValue: function () {
      return {
        replaceKeys: {
          "route[From](parental)": this.infoCity?.[0]?.city_from_case || this.infoCity?.[0]?.city_from || "",
          "route[From]": this.infoCity?.[0]?.city_from || "",
          "route[To]": this.infoCity?.[0]?.city_to_case || this.infoCity?.[0]?.city_to || "",
        }
      }
    },
    freightRateTableTemplateRoutesValue: function () {
      return {
        cityInfo: this.infoCity?.[0] || {}
      }
    }
  },

  components: {
    Breadcrumbs
  },

  methods: {
    openFormSubmitApplication: function () {
      this.$store.commit("back-call/setOpen", {
        open: true,
        settings: {
          title: "Оставить заявку",
          activeTab: "big",
          hideTabs: true,
          type: 'Оставить заявку'
        }
      });
    },
  }
}
